import axios from 'axios';
import setAuthorizationToken from '../utils/setAuthorizationToken';
import jwt from 'jsonwebtoken';
import { history } from '../store';
import { SET_CURRENT_USER, } from './types';
import { recordEvent } from '../utils/analyticsEvents';
import CommonConstants from '../utils/CommonConstants';
import { disabledCart } from '../utils/utils';
const apiUrl = CommonConstants.Actions.api;
const apiAuthUrl = CommonConstants.Actions.apiAuth;
const rootUrl = CommonConstants.Actions.rootUrl;

export function setCurrentUser(user){
  return{
    type: SET_CURRENT_USER,
    user,
  }
}
export function signin(email, password){
  return function(dispatch)  {
    dispatch({type: 'RESET_UPDATE_ACCOUNTS',})
    let token;
    axios.post(apiAuthUrl+'login',{
      'email' : email,
      'password' : password,
      'role': 'customer',
    }).then((response) => {
      token = response.data.token;
      localStorage.setItem('jwtToken', token);
      setAuthorizationToken(token);
      dispatch(setCurrentUser(jwt.decode(token)));
      dispatch({type: 'SIGNIN_USER_FULFILLED', payload: response.data,});
      //localStorage.trackPackage ? history.push('/track-package') : history.push('/cart');
      //localStorage.removeItem("trackPackage");
      return axios.get(apiUrl+'accounts',token);
    })
    .then((response) => {
      dispatch({type: 'SIGNEDIN_USER_FULFILLED', payload: response.data,});
      localStorage.trackPackage ? history.push('/track') :
      // localStorage.rewardPage ? window.location.replace(`https://rewards.shippingcart.com?token=${token}&account_number=${response.data.party.account_number}&name=${response.data.party.first_name}`) :
      !disabledCart ? window.location.replace(window.location.origin + "/cart") : window.location.replace(window.location.origin + "/shipment");
      localStorage.removeItem('rewardPage');
      localStorage.removeItem("trackPackage");
    })
    .catch((err) =>{
      dispatch({type: 'SIGNIN_USER_REJECTED', payload: err,})
    })
  }
}
export function signedIn(token){
  var timeStamp = Math.floor(Date.now() / 1000);
  return function(dispatch)  {
    axios.get(apiUrl+'accounts?'+timeStamp,token).then((response) => {
      localStorage.setItem('accountNumber', response.data.party.account_number);
      dispatch({type: 'SIGNEDIN_USER_FULFILLED', payload: response.data,});
    }).catch((err) =>{
      dispatch({type: 'SIGNEDIN_USER_REJECTED', payload: err,})
      setAuthorizationToken("");
      localStorage.removeItem('jwtToken');
      localStorage.removeItem('item');
      localStorage.removeItem('insurance');
      localStorage.removeItem('accountNumber');
      dispatch(setCurrentUser({}));
      history.push('/');
    })
  }
}
export function FacebookSignedIn(token){
  return function(dispatch)  {
    axios.post(apiAuthUrl+'fb-login',{"token":token,}).then((response) => {
      const token = response.data.token;
      localStorage.setItem('jwtToken', token);
      setAuthorizationToken(token);
      dispatch(setCurrentUser(jwt.decode(token)));
      dispatch({type: 'SIGNIN_USER_FULFILLED', payload: response.data,})
      !disabledCart ? history.push('/cart') : history.push('/shipment')

    }).catch((err) =>{
      dispatch({type: 'FACEBOOK_SIGNEDIN_USER_REJECTED', payload: err,})
    })
  }
}
export function FacebookSignedUp(token){
  return function(dispatch)  {
    axios.post(rootUrl+'sign-up-fb',{"token":token,}).then((response) => {
      const token = response.data.token;
      localStorage.setItem('jwtToken', token);
      setAuthorizationToken(token);
      dispatch(setCurrentUser(jwt.decode(token)));
      dispatch({type: 'SIGNUP_USER_FULFILLED', payload: response.data,})
      if (response.data.is_new) {
        recordEvent('sign_up_2019', 'Sign Up 2019', 'Completed', 'Facebook sign-up');
        history.push('/signup-success')
      } else {
        // disable cart for wasp
        !disabledCart ? history.push('/cart') : history.push('/shipment')
      }
    }).catch((err) =>{
      recordEvent('sign_up_2019', 'Sign Up 2019', 'Failed', 'Facebook sign-up');
      dispatch({type: 'FACEBOOK_SIGNEDIN_USER_REJECTED', payload: err,})
    })
  }
}
export function updateCustomerPassword(password,new_password,new_confirm_password,token){

  return function(dispatch){
    dispatch({type: 'RESET_UPDATE_ACCOUNTS',})
      axios.put(apiUrl+'users/update-password',
        {
            "data" : {
                "type": "user-update-password",
                "attributes" : {
                    "password":password,
                    "new_password":new_password,
                    "new_confirm_password":new_confirm_password
                }
            }
        }
        ).then((response) => {
        dispatch({type: 'UPDATE_CUSTOMER_PASSWORD_FULFILLED', payload: response.data,})
      }).catch((err) =>{
        dispatch({type: 'UPDATE_CUSTOMER_PASSWORD_REJECTED', payload: err.response,})
      })
    }
}
export function updateCustomerEmail(email,password_confirm,token){
  return function(dispatch){
    dispatch({type: 'RESET_UPDATE_ACCOUNTS',})
      axios.put(apiUrl+'users/update-email',
      {
        "data" : {
            "type": "user-update-email",
            "attributes" : {
                "email": email,
                "password_confirm": password_confirm
            }
        }
      }).then((response) => {
        dispatch({type: 'UPDATE_CUSTOMER_EMAIL_FULFILLED', payload: response.data,})
      }).catch((err) =>{
        dispatch({type: 'UPDATE_CUSTOMER_EMAIL_REJECTED', payload: err.response,})
      })
    }
}
export function addCustomerProfile(parameter, otp_code){
  const attributes = (otp_code) ? {...parameter,otp_code} : {...parameter[0]}
  return function(dispatch){
    dispatch({type: 'RESET_UPDATE_ACCOUNTS',})
    axios.put(apiUrl+'users/update-profile',
      {
          "data" : {
              "type": "user-update-profile",
              attributes
          }
      }
      ).then((response) => {
      dispatch({type: 'UPDATE_CUSTOMER_PROFILE_FULFILLED', payload: response.data,})
      if (otp_code){
        history.goBack();
      }
    }).catch((err) =>{
      dispatch({type: 'UPDATE_CUSTOMER_PROFILE_REJECTED', payload: err.response,})
    })
  }
}

export function updateCustomerProfile(otp_payload,otp_code,phone_number_update,first_name,last_name,phone_number,gender,birthday,token){
  
  const attributes = (otp_code !== null) ? {...otp_payload,otp_code} : 
  ({
    "first_name": first_name,
    "last_name": last_name,
    "phone_number": phone_number,
    "gender": gender,
    "birthdate": birthday,
    "phone_number_update": phone_number_update,
  })
  return function(dispatch){
      dispatch({type: 'RESET_UPDATE_ACCOUNTS',})
      axios.put(apiUrl+'users/update-profile',
        {
            "data" : {
              "type": "user-update-profile",
              attributes
            }
        }
        ).then((response) => {
        dispatch({type: 'UPDATE_CUSTOMER_PROFILE_FULFILLED', payload: response.data,})
        if (otp_code !== null){
          localStorage.removeItem('otp_response');
          localStorage.removeItem('otp_redirect');
          localStorage.setItem('account_redirect', true);
          history.goBack('');
        }
      }).catch((err) =>{
        dispatch({type: 'UPDATE_CUSTOMER_PROFILE_REJECTED', payload: err.response,})
      })
    }
}

export function changePassword(new_password,new_confirm_password,email,token){

  return function (dispatch) {
      dispatch({type: 'RESET_UPDATE_ACCOUNTS',})

      axios.put(apiUrl + 'users/reset-password',
        {
          "data" : {
              "type": "user-reset-password",
              "attributes" : {
                  "email": email,
                  "new_password" : new_password,
                  "new_password_confirmation" : new_confirm_password,
                  "token": token
                }
            }
        })
      .then((response) => {
        let sessionToken = response.data.token;
        setAuthorizationToken(sessionToken);

        localStorage.setItem('jwtToken', sessionToken);
        localStorage.setItem("ChangePassword","true");

        dispatch(setCurrentUser(jwt.decode(sessionToken)));
        dispatch({type: 'CHANGE_PASSWORD_FULFILLED', payload: response.data,});

        !disabledCart ? window.location.replace("/cart") : window.location.replace("/shipment");

      }).catch((err) =>{
        dispatch({type: 'CHANGE_PASSWORD_REJECTED', payload: err,})
      });
  }
}

export function resetPassword(email){
  return function(dispatch){
      dispatch({type: 'RESET_UPDATE_ACCOUNTS',})
      axios.post(apiUrl+'forgot/password',
        {
        "email" : email,
      }).then((response) => {
        dispatch({type: 'RESET_PASSWORD_FULFILLED', payload: response.data,});
        localStorage.setItem("resetPassword","true");
        history.push('/signin');
      }).catch((err) =>{
        dispatch({type: 'RESET_PASSWORD_REJECTED', payload: err,})
      })
    }
}
export function resetAccounts(){
  return function(dispatch){
      dispatch({type: 'RESET_UPDATE_ACCOUNTS',})
    }
}
export function logout(){
  return function(dispatch){
    axios.post(apiAuthUrl+'logout')
      .then((response) => {
        setAuthorizationToken("");
        localStorage.removeItem('jwtToken');
        localStorage.removeItem('token');
        localStorage.removeItem('cartModalShowed');
        localStorage.removeItem('cartExtensionModalShowed');
        localStorage.removeItem('checkoutModalShowed');
        localStorage.removeItem('item');
        localStorage.removeItem('insurance');
        localStorage.removeItem('shipment_location_details');
        localStorage.removeItem('warehouse_id');
        localStorage.removeItem('accountNumber');
        dispatch(setCurrentUser({}));
        dispatch({type: 'LOGOUT_FULFILLED',})
      })
      .catch((error) => {
        setAuthorizationToken("");
        localStorage.removeItem('jwtToken');
        localStorage.removeItem('token');
        localStorage.removeItem('cartModalShowed');
        localStorage.removeItem('cartExtensionModalShowed');
        localStorage.removeItem('checkoutModalShowed');
        localStorage.removeItem('item');
        localStorage.removeItem('insurance');
        localStorage.removeItem('shipment_location_details');
        localStorage.removeItem('warehouse_id');
        localStorage.removeItem('accountNumber');
        dispatch(setCurrentUser({}));
        dispatch({type: 'LOGOUT_FULFILLED',})
      });
    }
}
export function getCopyrightYear(){
  return function(dispatch){
      axios.get(apiUrl+'year')
      .then((response) => {
        dispatch({type: 'GET_YEAR_FULFILLED', payload: response.data,})
      }).catch((err) =>{
        dispatch({type: 'GET_YEAR_REJECTED', payload: err,})
      })
    }

}

export function testLogin(email,passcode){
  return function(dispatch){
      axios.post(apiAuthUrl+'gm-login',{
        email,
        passcode,
      })
      .then((response) => {
        const token = response.data.token;
        localStorage.setItem('jwtToken', token);
        setAuthorizationToken(token);
        dispatch(setCurrentUser(jwt.decode(token)));
        dispatch({type: 'SIGNIN_USER_FULFILLED', payload: response.data,});
        //localStorage.trackPackage ? history.push('/track-package') : history.push('/cart');
        //localStorage.removeItem("trackPackage");
        return axios.get(apiUrl+'accounts',token);
      })
      .then((response) => {
        dispatch({type: 'SIGNEDIN_USER_FULFILLED', payload: response.data,});
        localStorage.trackPackage ? history.push('/track') : history.push('/cart');
        localStorage.removeItem("trackPackage");
      })
      .catch((err) =>{
        dispatch({type: 'SIGNIN_USER_REJECTED', payload: err,})
      });
    }

}

export function putReSendOTP(otp_payload,phone_number_update,first_name,last_name,phone_number,gender,birthday){
  let attributes = null;
  attributes = (otp_payload !== null) ?
  ({
    "first_name":otp_payload.first_name,
    "last_name":otp_payload.last_name,
    "phone_number":otp_payload.phone_number,
    "gender":otp_payload.gender,
    "birthdate":otp_payload.birthday,
    "phone_number_update":otp_payload.phone_number_update,
  }) :
  ({
    "first_name":first_name,
    "last_name":last_name,
    "phone_number":phone_number,
    "gender":gender,
    "birthdate":birthday,
    "phone_number_update":phone_number_update,
  })
  return function(dispatch){
      dispatch({type: 'RESET_UPDATE_ACCOUNTS',})
      axios.put(apiUrl+'users/update-profile',
        {
            "data" : {
              "type": "user-update-profile",
              attributes
            }
        }
        ).then((response) => {
        dispatch({type: 'SEND_OTP_FULFILLED', payload: response.data,})
        if (phone_number_update) {
          localStorage.setItem("otp_response", JSON.stringify(response.data))
          localStorage.setItem("otp_redirect", "account");
          history.push('/otp-service');
        }
      }).catch((err) =>{
        dispatch({type: 'SEND_OTP_REJECTED', payload: err.response,})
      })
    }
}

export function putReSendOTPRequired(otp_payload){
  let attributes = null;
  if (otp_payload[0] && !otp_payload[0].gender){
    attributes = {
      "first_name":otp_payload[0].first_name,
      "last_name":otp_payload[0].last_name,
      "phone_number":otp_payload[0].phone_number,
      "phone_number_update":otp_payload[0].phone_number_update,
    }
    if (otp_payload[0].email) {
      attributes.email = otp_payload[0].email
    }
  } else {
    attributes = {
      "first_name":otp_payload.first_name,
      "last_name":otp_payload.last_name,
      "phone_number":otp_payload.phone_number,
      "phone_number_update":otp_payload.phone_number_update,
    }
    if (otp_payload.email) {
      attributes.email = otp_payload[0].email
    }
  }

  return function(dispatch){
      dispatch({type: 'RESET_UPDATE_ACCOUNTS',})
      axios.put(apiUrl+'users/update-profile',
        {
            "data" : {
              "type": "user-update-profile",
              attributes
            }
        }
        ).then((response) => {
        dispatch({type: 'SEND_OTP_FULFILLED', payload: response.data,})
        if (otp_payload[0] && !otp_payload[0].gender){
          localStorage.setItem("otp_response", JSON.stringify(response.data))
          localStorage.setItem("otp_redirect", "requiredModal");
          history.push('/otp-service');
        }
      }).catch((err) =>{
        dispatch({type: 'SEND_OTP_REJECTED', payload: err.response,})
      })
    }
}
export function updateTutorial(type){
  return function(dispatch){
    dispatch({type: 'RESET_UPDATE_ACCOUNTS',})
      axios.put(apiUrl+'users/hide-tutorial',
      {
        "data" : {
            "type": "user-hide-tutorial",
            "attributes" : {
                [type]: true,
            }
        }
      }).then((response) => {
        dispatch({type: 'UPDATE_CUSTOMER_TUTORIAL_FULFILLED', payload: response.data.original,})
      }).catch((err) =>{
        dispatch({type: 'UPDATE_CUSTOMER_PROFILE_REJECTED', payload: err.response,})
      })
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/Signin.js
 **/